import { render, staticRenderFns } from "./agentLayout.vue?vue&type=template&id=e2c4d4f8&scoped=true"
import script from "./agentLayout.vue?vue&type=script&lang=js"
export * from "./agentLayout.vue?vue&type=script&lang=js"
import style0 from "./agentLayout.vue?vue&type=style&index=0&id=e2c4d4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4d4f8",
  null
  
)

export default component.exports